import Heading from 'LuxKit/Typography/Heading'
import type { PropsWithChildren } from 'react'
import React from 'react'

interface Props extends PropsWithChildren {
}

function SearchTileRowTitle({ children }: Props) {
  return <Heading variant="heading5" lineClamp={3}>
    {children}
  </Heading>
}

export default SearchTileRowTitle
